import styled from 'styled-components'

export const App = styled.main`
    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }

    body {
        font-family: Poppins;
    }
    height: 100vh;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    ::-webkit-scrollbar {
        width: 0px;
        height: 0px;
      }

    @media (min-width: 768px) {
        ::-webkit-scrollbar {
            width: 8px;
            height: 8px;
            background-color: rgba(0, 0, 0, 0.17);
            border-radius: 5px;
          }
          
        ::-webkit-scrollbar-thumb {
            background-color: rgba(0,0,0,0.25);
            border-radius: 5px;
        }
    }
    .featurette > * {
        flex-shrink: 0;
        padding-right: calc(var(--bs-gutter-x) * .5);
        padding-left: calc(var(--bs-gutter-x) * .5);
        margin-top: var(--bs-gutter-y);
    }
}
`;